<template>
  <div>
    <div class="heading">Brands</div>
    <div class="navs row">
      <div class="small-10 columns">
        <ul>
          <li :class="{'active':tab === 0}" @click="tab = 0">WEBFORMS</li>
          <li :class="{'active':tab === 1}" @click="tab = 1">BRANDS</li>
        </ul>
      </div>

      <div class="small-2 columns add-form">
        <div :class="{'button cta small success':true, 'disabled':webformLoading || serviceAreaLoading}"
          @click="showForm" v-show="tab === 0">
          <i class="fas fa-plus"></i>
          <span>Add Webform</span>
        </div>
        <div class="button cta small success" @click="showForm" v-show="tab === 1">
          <i class="fas fa-plus"></i>
          <span>Add Brand</span>
        </div>
      </div>
    </div>

    <webform-list v-show="tab === 0" :isMobile="isMobile"></webform-list>
    <brand-list v-show="tab === 1" :isMobile="isMobile"></brand-list>
    <brand-add></brand-add>
    <webform-add></webform-add>
  </div>
</template>

<script>
import brandList from './BrandList'
import brandAdd from './BrandAdd'
import webformList from './WebformList'
import webformAdd from './WebformAdd'
// import ApiBrands from '@/modules/api/brands'

export default {
  name: 'brands',
  components: { brandList, brandAdd, webformList, webformAdd },
  data () {
    return {
      tab: 0,
      isMobile: false
    }
  },
  computed: {
    brandFormShow () { return this.$store.state.brands.showBrandForm },
    webformShow () { return this.$store.state.brands.webform.show },
    webformLoading () { return this.$store.state.brands.webform.loading },
    serviceAreaLoading () { return this.$store.state.brands.serviceArea.loading }
  },
  methods: {
    showForm () {
      if (this.tab === 1) {
        this.$store.commit('brands/setShowBrandForm', true)
      } else {
        this.$store.commit('brands/setWebformShow', true)
      }
    },
    setScreenSize() {
      let self = this
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        self.isMobile = true
      } else {
        self.isMobile = false
      }
    }
  },
  watch: {
    brandFormShow: function (value) {
      if (value) {
        document.documentElement.style.overflow = 'hidden'
      } else {
        document.documentElement.style.overflow = 'auto'
      }
    },
    webformShow: function (value) {
      if (value) {
        document.documentElement.style.overflow = 'hidden'
      } else {
        document.documentElement.style.overflow = 'auto'
      }
    }
  },
  mounted () {
    this.setScreenSize()
  }
}
</script>

<style lang="scss" scoped>
.heading{
  margin-left: 50px;
  padding-left: 10px;
  height: 50px;
  background: #fff;
  border-bottom: 1px solid #ddd;
  line-height: 50px;
  color: #3F2975;
  font-size: 21px;
  font-weight: 600;
  text-transform: uppercase;
}

.navs{
  border-bottom: 1px solid #ccc;
  max-width: 100%;

  ul{
    list-style: none;
    padding: 0;
    margin: 0;
    font-size: 14px;

    li{
      display: inline-block;
      padding: 13px 15px;
      color: #0D79F2;
      font-weight: 600;
      cursor: pointer;
      border:1px solid transparent;
      text-decoration: underline;
    }
    .active{
      background: #fff;
      border-right-color: #ccc;
      border-left-color: #ccc;
      cursor: default;
      text-decoration: none;
    }
  }
  .add-form{
    text-align: right;
    i{ margin-right: 5px; }
  }
  .button{ margin: 5px 15px 5px 0; }
}

@media only screen and (max-width: 430px) {
  .small-10 {
    width: 100%;
  }
  .add-form {
    position: fixed;
    bottom: 0;
    width: 100%;
    text-align: center !important;
    background-color: #fff;
    padding: 5px 0;
  }

  .navs ul li {
    width: 49%;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Brands/index.vue